<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form>
					<c-form-item type="select" label="商品分类" name="product_type_id" options="PRODUCT_CLASSIFY"></c-form-item>
					<c-form-item type="input" label="货号" name="product_itemnumber"></c-form-item>
					<c-form-item type="input" label="商品名称" name="product_name"></c-form-item>
					<c-form-item type="datetime" label="上下架时间" start-name="sell_state_start_date" end-name="sell_state_end_date"></c-form-item>
					<c-form-item type="checkbox" name="state" :options="productState"></c-form-item>
				</c-form>
			</m-search>
			
			<m-operate>
				<c-button power="b_product_edit" color="sys" @click="selectClassify()">发布商品</c-button>
				<c-button power="b_product_sold" color="black" hollow @click="soldHandle('in')">批量上架</c-button>
				<c-button power="b_product_sold" color="black" hollow @click="soldHandle('out')">批量下架</c-button>
				<c-button power="b_product_tag_set" color="black" hollow @click="setTags(1)">批量设置标签</c-button>
                <c-button power="b_product_import" icon="upload" color="black" @click="viewImportHistory()">商品导入</c-button>
			</m-operate>
			
			<c-table ref="table" code="product_list">
				<c-table-column
					type="selector"
				></c-table-column>
				
				<c-table-column
					label="状态"
					name="state"
					width="50"
				>
					<template v-slot="{data}">
            <span v-if="data.state == 0" style="color:red">{{productStateName[data.state]}}</span>
            <span v-if="data.state == 1" style="color:dodgerblue">{{productStateName[data.state]}}</span>
            <span v-if="data.state == 2" style="color:green">{{productStateName[data.state]}}</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="货号"
					name="product_itemnumber"
				></c-table-column>
				
				<c-table-column
					label="商品信息"
					name="product_name"
					width="350"
				>
					<template v-slot="{data}">
						<product-info :image="data.product_img_url" :name="data.product_name"></product-info>
					</template>
				</c-table-column>
				
				<!-- <c-table-column
					label="商品卖点"
					name="product_subtitle"
					width="100"
				></c-table-column> -->
				
				<c-table-column
					label="所属分类"
					name="product_type_full_name"
					width="200"
				></c-table-column>
				
				<c-table-column
					label="售价(元)"
					name="product_price"
					width="140"
				>
					<template v-slot="{data}">
						￥{{data.product_price}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="创建时间"
					name="create_date"
					width="140"
				></c-table-column>
				
				<c-table-column
					label="上下架时间"
					name="sell_state_date"
					width="140"
				></c-table-column>
				
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="190"
				>
					<template v-slot="{data}">
						<c-table-button power="b_product_edit" @click="navigateTo(`/product_edit/${data.product_id}`)">编辑</c-table-button>
						<c-table-button power="b_product_sold" v-if="data.state == 1" @click="soldHandle('in', data)">上架</c-table-button>
						<c-table-button power="b_product_sold" v-else-if="data.state == 2" @click="soldHandle('out', data)">下架</c-table-button>
						<c-table-button power="b_product_stock" @click="setStock(data)">库存设置</c-table-button>
                        <c-table-button power="b_product_edit" v-if="data.state == 0 || data.state == 1" @click="delHandle(data)">删除</c-table-button>
                        <c-table-button power="b_product_tag_set" @click="setTags(0,data)">标签设置</c-table-button>

                    </template>
				</c-table-column>
			</c-table>
		</module>
		
		<c-dialog ref="classifySelector" title="选择商品类目" width="750" @resolve="createProduct" @close="getClassify(0)">
			<div class="classify-select flex-center">
				<dl v-for="(level, i) in productClassify" :key="i">
					<dt>
						<i class="tf tf-search"></i>
						<input v-model="classifySearch[i]" type="text" @keyup.enter="getClassify(i)">
					</dt>
					<dd>
						<ul>
							<li v-for="(item, j) in level" :key="j" class="flex-between-center" :class="{'z-crt': item == currentClassify[i]}" @click="classifyHandle(item, i)">
								<span>{{item.type_name}}</span>
								<i v-show="item.is_parent > 0" class="tf tf-angle-right"></i>
							</li>
						</ul>
					</dd>
				</dl>
			</div>
		</c-dialog>
		
		<c-dialog ref="stockEdit" title="库存设置" width="750" @resolve="setStockHandle">
			<c-table ref="stockTable" height="500" :paging="false">
				<c-table-column
					label="规格名称"
					name="product_sku_spec"
					width="300"
				></c-table-column>
				
				<c-table-column
					label="当前库存"
					name="product_sku_stock"
					width="150"
				></c-table-column>
				
				<c-table-column
					label="增减库存"
					width="150"
				>
					<template v-slot="{data}">
						<c-input v-model="data.revise_stock" type="number" :limit="[-data.product_sku_stock, 9999]"></c-input>
					</template>
				</c-table-column>
				
				<c-table-column
					label="调整后库存"
					name="product_sku_stock"
					width="150"
				>
					<template v-slot="{data}">
						{{parseInt(data.product_sku_stock) + (parseInt(data.revise_stock) || 0)}}
					</template>
				</c-table-column>
			</c-table>
		</c-dialog>

        <c-dialog ref="tagEdit" title="标签设置" width="750" height="400" @resolve="setTagHandle">
            <div class="tag-list">
				<c-checkbox-group v-model="currentProductTag">
					<c-checkbox v-for="(item, i) in productTagList" :key="i" :value="item.id" class="tag-item">
						<img v-if="item.tag_img" class="tag-img" :src="item.tag_img" alt="">
						<span v-else class="tag-text" :style="{'border-color': item.tag_color, 'color': item.tag_color}">{{item.tag_name}}</span>
					</c-checkbox>
				</c-checkbox-group>
            </div>
        </c-dialog>

        <c-dialog ref="importHistoryListEdit" @close="closeImportHistoryListEdit" title="商品导入任务历史(近7天)" width="1050" :button="false">

            <m-operate>
                <c-button power="b_product_import"  color="black" @click="importProduct()">导入</c-button>
                <c-button  color="black" hollow @click="flushImportTable()">刷新</c-button>
            </m-operate>

            <c-table ref="importHistoryListTable" height="500">

                <c-table-column
                        label="任务ID"
                        name="id"
                ></c-table-column>

                <c-table-column
                        label="状态"
                        name="state"
                >
                    <template v-slot="{data}">
                        <span v-if="data.state==0"><span style="color:#888888">待导入</span></span>
                        <span v-if="data.state==1"><span >导入中</span></span>
                        <span v-if="data.state==2"><span style="color:darkgreen">导入完成</span></span>
                        <span v-if="data.state==3"><span style="color:red">导入异常</span></span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="错误原因"
                        name="err_msg"
                        width="250"
                >
                    <template v-slot="{data}">
                        <span v-if="data.err_msg"><span style="color:#888888">缺少指定列[{{data.err_msg}}]</span></span>
                    </template>
                </c-table-column>


                <c-table-column
                        label="任务总条数"
                        name="total_items"
                ></c-table-column>

                <c-table-column
                        label="导入成功条数"
                        name="success_items"
                ></c-table-column>

                <c-table-column
                        label="导入失败条数"
                        name="err_items"
                ></c-table-column>

                <c-table-column
                        label="任务时间"
                        name="create_date"
                        width="140"
                ></c-table-column>

                <c-table-column
                        label="文件下载"
                        name="err_file_name"
                        width="100"
                >
                    <template v-slot="{data}">
                        <a v-if="data.err_file_path" class="s-link" :href='data.err_file_path' target="_blank">下载错误文件</a>
                        <a v-if="data.err_msg" class="s-link" :href='data.file_path' target="_blank">下载原文件</a>
                    </template>
                </c-table-column>

            </c-table>
        </c-dialog>

    </page>
</template>

<script>
	import productInfo from '@/components/public/product_info.vue'
	import {mapState} from 'vuex'
	
	export default {
		name: 'm_product_list',
		
		components: {
			productInfo
		},
		
		data() {
			return {
				productState: [{
					name: '草稿',
					value: 0
				}, {
					name: '上架',
					value: 2
				}, {
					name: '下架',
					value: 1
				}],
				
				productClassify: [
					[], [], []
				],
				currentClassify: [],
				classifySearch: [],
				currentClassifyId: '',
                flushImportHisTableTimer: null,
				productTagList: [],
				currentProductTag: []
			}
		},
		
		computed: {
			...mapState({
				productStateName: state => state.dict.productState
			})
		},
		
		mounted() {
			this.$refs.search.search();
			
			this.$bus.$on('productList.update', page => {
				this.$refs.table.update(page);
			});
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/product/list',
					data
				});
			},
			
			selectClassify() {
				if (!this.productClassify[0].length) {
					this.getClassify(0, 0);
				}
				this.$refs.classifySelector.open();
			},
			
			classifyHandle(item, level) {
				this.currentClassifyId = item.id;
				this.$set(this.currentClassify, level, item);
				if (level < 2) {
					this.getClassify(level+1, !item.is_parent);
				}
			},
			
			getClassify(level, empty) {
				new Promise(resolve => {
					if (empty) {
						resolve([]);
					} else {
						this.request({
							url: '/product_type/common_list',
							data: {
								type_name: this.classifySearch[level],
								parent_id: level ? this.currentClassify[level-1].id : 0
							},
							success: data => {
								if (!data) {
									this.$message({
										text: '未找到分类'
									});
									return;
								}
								
								resolve(data);
							}
						});
					}
				}).then(data => {
					this.$set(this.productClassify, level, data);
					for (let i=level; i<3; i++) {
						i > level && this.$set(this.productClassify, i, []);
						this.$set(this.currentClassify, i, undefined);
					}
					this.currentClassifyId = level ? this.currentClassify[level-1].id : '';
				});
				this.$set(this.classifySearch, level, '');
			},
			
			createProduct(stop) {
				if (!this.currentClassifyId) {
					stop();
					this.$message({
						text: '请选择分类'
					});
					return;
				}
				
				var name = [];
				this.currentClassify.forEach(item => {
					item && name.push(item.type_name);
				});
				this.navigateTo({
					path: '/product_apply',
					query: {
						classify: this.currentClassifyId,
						classifyName: name.join(',')
					}
				});
			},
			
			soldHandle(type, item) {
				var list = item ? [{
					data: item
				}] : this.$refs.table.getRow('selected');
				if (!list.length) {
					this.$message({
						text: '请选择要操作的商品'
					});
					return;
				}
				
				this.$confirm({
					text: `确定要${type == 'in' ? '上架' : '下架'}${item ? '该' : '所选'}商品吗？`,
					resolve: () => {
						this.request({
							url: '/product/sold',
							data: {
								type: type == 'in' ? 1 : 2,
								product_ids: Array.from(list, item => item.data.product_id)
							},
							loading: true,
							success: () => {
								list.forEach(item => {
									item.data.state = type == 'in' ? 2 : 1
								});
							}
						});
					}
				});
			},

			delHandle(params) {
				this.$confirm({
					text: '确定要删除商品【'+params.product_name+'】吗？',
					resolve: () => {
						this.request({
							url: '/product/del',
							data: {
								product_id: params.product_id
							},
							loading: true,
							success: data => {
								this.$message({
									text: '商品删除成功！',
									icon: 'success'
								});
								this.$refs.table.update();
							}
						});
					}
				});
			},

			setStock(item) {
				this._setStockId = item.product_id;
				this.$refs.stockEdit.open();
				this.$refs.stockTable.load({
					url: '/product/get_sku_stock',
					data: {
						product_id: item.product_id
					},
					dataFormatter: data => {
						data.forEach(item => {
							item.revise_stock = '';
						});
						return data;
					}
				});
			},
			
			setStockHandle(stop) {
				stop();
				this.request({
					url: '/product/set_sku_stock',
					data: {
						product_id: this._setStockId,
						product_sku_stock_list: Array.from(this.$refs.stockTable.getRow(), item => {
							return {
								product_sku: item.data.product_sku,
								product_total_count: parseInt(item.data.revise_stock) || 0
							}
						})
					},
					loading: true,
					success: data => {
						this.$message({
							text: '库存设置成功'
						});
						this.$refs.stockEdit.close();
					}
				});
			},

            setTags(batch,item) {
                this.tagProductIds = [];
                if(batch == 1){
                    var list = this.$refs.table.getRow('selected');
                    if (!list.length) {
                        this.$message({
                            text: '请选择要操作的商品'
                        });
                        return;
                    }
                    this.tagProductIds = Array.from(list,item=>{
                        return item.data.product_id;
                    })
                }else{
                    this.tagProductIds.push(item.product_id);
                }
                this.request({
                    url: '/product/get_product_tags',
                    data: {
                        is_batch: batch,
                        product_id: batch == 0 ? item.product_id : null
                    },
                    loading: true,
                    success: data => {
						this.productTagList = data.all_tags;
						this.$nextTick(() => {
							this.currentProductTag = Array.from(data.product_tags, item => {
								return item.tag_id;
							});
						});
                        this.$refs.tagEdit.open();
                    }
                });

            },

            setTagHandle(stop) {
                stop();
                this.request({
                    url: '/product/set_product_tags',
                    data: {
                        product_ids: this.tagProductIds,
                        tag_ids: this.currentProductTag
                    },
                    loading: true,
                    success: data => {
                        this.$message({
                            text: '标签设置成功'
                        });
                        this.$refs.tagEdit.close();
                    }
                });
            },

            flushImportTable(){
                this.$refs.importHistoryListTable.load({
                    url: '/import_job/list',
                    dataFormatter: data => {
                        return data;
                    }
                });
            },


            viewImportHistory(){
                this.$refs.importHistoryListEdit.open();
                this.loadFlushHisTableTimer();
                this.$refs.importHistoryListTable.load({
                    url: '/import_job/list',
                    dataFormatter: data => {
                        return data;
                    }
                });
            },

            loadFlushHisTableTimer(){
                this.flushImportHisTableTimer = setInterval(()=>{
                    this.$refs.importHistoryListTable.load({
                        url: '/import_job/list',
                        dataFormatter: data => {
                            return data;
                        }
                    });
                },10000)
            },

            closeImportHistoryListEdit(){
                clearInterval(this.flushImportHisTableTimer);
                this.flushImportHisTableTimer =null;
            },

            importProduct() {
                this.$confirm({
                    title: '导入提示',
                    buttonName: '开始导入',  // 确定按钮文字
                    text: '请使用标准模板进行导入商品 <a href="https://cdn.tkvip.com/app_static/base/%E5%95%86%E5%93%81%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx" target="_blank" style="color:dodgerblue;">模板下载</a>',
                    resolve: () => {
                        this.uploadFile({
                            message: false,
                            success: data => {
                                this.request({
                                    url: '/import_job/add',
                                    data: {
                                        filePath: data.filePath
                                    },
                                    loading: true,
                                    timeout: false,
                                    success: (data, message) => {
                                        this.$message({
                                            text: "导入任务提交成功,导入结果稍后查询",
                                            icon: 'success'
                                        });
                                        this.$refs.importHistoryListTable.update();
                                    }
                                });
                            }
                        });
                    }
                })
            },

        }
	}
</script>

<style lang="stylus" scoped>
	.classify-select {
		padding: 10px;
		
		dl {
			width: 240px;
			border: 1px solid #ddd;
			
			&:nth-child(n+2) {
				border-left: none;
			}
			
			dt {
				position: relative;
				padding: 10px;
			
				.tf {
					position: absolute;
					width: 30px;
					line-height: 36px;
					font-size: 14px;
					text-align: center;
					color: #bbb;
				}
				
				input {
					box-sizing: border-box;
					width: 100%;
					height: 36px;
					border: none;
					padding: 0 10px 0 30px;
					background: #F5F5F5;
				}
			}
			
			dd {
				height: 290px;
				overflow: auto;
				
				li {
					padding: 0 14px;
					line-height: 36px;
					font-size: 13px;
					cursor: pointer;
					
					&:hover,
					&.z-crt {
						background: #FFF17E;
					}
				}
			}
		}
	}
	
	.tag {
		&-list {
			padding: 20px 20px 20px 10px;
		}
		
		&-item {
			margin-left: 10px;
		}
		
		&-img {
			height: 20px;
		}
		
		&-text {
			border: 1px solid #000;
			padding: 0 6px;
			line-height: 18px !important;
			font-size: 12px;
			font-weight: normal !important;
			color: #000;
		}
	}
</style>